import { render, staticRenderFns } from "./interview-record.vue?vue&type=template&id=0f35ed09&scoped=true"
import script from "./interview-record.vue?vue&type=script&lang=js"
export * from "./interview-record.vue?vue&type=script&lang=js"
import style0 from "./interview-record.vue?vue&type=style&index=0&id=0f35ed09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35ed09",
  null
  
)

export default component.exports